import { useEffect } from 'react';

import { GatewayRuleConditionsProvider } from 'pages/GatewayRules/context/GatewayRuleConditionsContext';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListContext, RecordContextProvider } from 'react-admin';
import { Card } from 'shared/mui/Card';
import { Typography } from 'shared/mui/Typography';
import { GatewayRule } from 'types/embedded/gatewayRule';

import { GatewayRuleCard } from './GatewayRuleCard/GatewayRuleCard';
import { GatewayRulesDatagridSkeleton } from './GatewayRulesDatagridSkeleton';

type GatewayRulesDatagridProps = {
  resetExpandedRules: () => void;
};

export const GatewayRulesDatagrid: React.FC<GatewayRulesDatagridProps> = ({
  resetExpandedRules,
}) => {
  const translate = useTypedTranslate();
  const { data = [], isLoading } = useListContext<GatewayRule>();

  useEffect(() => {
    resetExpandedRules();
  }, [data]);

  if (!data.length && !isLoading) {
    return (
      <Typography marginLeft={2} variant="body2">
        {translate('app.common.noResults')}
      </Typography>
    );
  }

  return (
    <Card
      sx={{
        overflow: 'auto',
        backgroundColor: 'transparent',
      }}
    >
      {isLoading ? (
        <GatewayRulesDatagridSkeleton />
      ) : (
        data.map((record: GatewayRule) => (
          <RecordContextProvider key={record.id} value={record}>
            <GatewayRuleConditionsProvider>
              <GatewayRuleCard />
            </GatewayRuleConditionsProvider>
          </RecordContextProvider>
        ))
      )}
    </Card>
  );
};
